// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioButton__button-ad6f46 {
  margin: 8px 8px 0 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/RadioButton/FormRadioButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF","sourcesContent":[".button {\n  margin: 8px 8px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `RadioButton__button-ad6f46`
};
module.exports = ___CSS_LOADER_EXPORT___;
